<template>
    <AppLayout>
        <PageHero title="Books" description="Companion books to support your Arabic and Qur'an learning journey." />

        <Container>
            <div class="grid grid-cols-1 gap-8 py-16 sm:grid-cols-2 lg:grid-cols-3">
                <div v-for="book in books" :key="book.id"
                    class="group flex flex-col overflow-hidden rounded-2xl bg-white shadow-sm ring-1 ring-gray-900/5 transition-shadow hover:shadow-xl">
                    <div class="aspect-3/4 overflow-hidden bg-gray-100">
                        <img :src="book.thumbnail" :alt="book.title"
                            class="size-full object-cover transition-transform duration-300 group-hover:scale-105" />
                    </div>
                    <div class="flex flex-1 flex-col p-6">
                        <h2 class="text-lg font-semibold text-gray-900">{{ book.title }}</h2>
                        <p class="mt-2 flex-1 text-sm text-gray-600 line-clamp-3">{{ stripHtml(book.description) }}</p>
                        <div class="mt-6 flex items-center justify-between">
                            <p class="text-2xl font-semibold text-gray-900">${{ book.price }}</p>
                            <Button variant="primary" size="sm"
                                @click="$router.push({ name: 'books.checkout', params: { id: book.id } })">
                                Buy Now
                            </Button>
                        </div>
                    </div>
                </div>
            </div>

            <div v-if="books?.content" class="cms-content mx-auto max-w-3xl pb-16" v-html="books.content"></div>
        </Container>
    </AppLayout>
</template>

<script setup>
import AppLayout from '@/components/layouts/AppLayout.vue';
import Container from '@/components/ui/Container.vue';
import PageHero from '@/components/ui/PageHero.vue';
import Button from '@/components/ui/Button.vue';
import { ref } from 'vue';
import { getBooks } from '@/services/bookService.js';

const books = ref([]);

const stripHtml = (html) => (html || '').replace(/<[^>]*>/g, ' ').replace(/\s+/g, ' ').trim();

const fetchBooks = async () => {
    const response = await getBooks();
    books.value = response.data;
}

fetchBooks();
</script>
